import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { locationClient } from '@/api/clients/locationClient';
import type { UserLocation } from '@/api/types/userLocationTypes';

/**
 * Retrieves any user location information. Does not require user to be authenticated
 */
export function useLocationQuery(): UseQueryResult<UserLocation | undefined> {
  return useQuery({
    //retry DO not retry for location queries, as they are not critical and can fail
    throwOnError: false,
    queryKey: ['useLocationQuery'],
    queryFn: async () => {
      return await locationClient.getUserLocation();
    },
  });
}
